var userProfile = { age: null, heightInches: 64, weightLbs: 120, bust: 34, waist: 28, hip: 37, bodyShape: null };
var hUnit = 'in', wUnit = 'lb';

function openOglModal(mode) {
  document.getElementById('ogl-app-modal').style.display = 'flex';
  if (mode === 'quiz') {
    document.getElementById('ogl-view-chart').classList.remove('active');
    document.getElementById('ogl-view-quiz').classList.add('active');
    goStep(1);
  } else {
    document.getElementById('ogl-view-quiz').classList.remove('active');
    document.getElementById('ogl-view-chart').classList.add('active');
  }
}
function closeOglModal() { document.getElementById('ogl-app-modal').style.display = 'none'; }

function goStep(s) {
  document.querySelectorAll('.ogl-q-step').forEach(function (p) { p.classList.remove('active'); });
  document.getElementById('q-step-' + s).classList.add('active');
  document.querySelectorAll('#quiz-dots-nav .ogl-dot').forEach(function (d, i) {
    d.classList.toggle('active', i === s - 1);
  });
  if (s === 6) calculateAccurateFit();
}
function saveQuizData(key, val) { userProfile[key] = val; }

function onHeightChange(v) {
  v = parseInt(v, 10);
  var disp = document.getElementById('val-disp-height');
  var btn = document.getElementById('btn-submit-h');
  if (hUnit === 'in') {
    userProfile.heightInches = v;
    var ft = Math.floor(v / 12), inch = v % 12;
    disp.innerText = ft + ' ft ' + inch + ' in';
    btn.innerText = 'I am ' + ft + "'" + inch + '"';
  } else {
    userProfile.heightInches = v / 2.54;
    disp.innerText = v + ' cm';
    btn.innerText = 'I am ' + v + ' cm';
  }
}
function setHUnit(u) {
  if (u === hUnit) return;
  var inches = userProfile.heightInches;
  hUnit = u;
  document.getElementById('btn-h-in').classList.toggle('active', u === 'in');
  document.getElementById('btn-h-cm').classList.toggle('active', u === 'cm');
  var s = document.getElementById('slider-h');
  s.min = (u === 'cm') ? 140 : 54;
  s.max = (u === 'cm') ? 200 : 74;
  s.value = (u === 'cm') ? Math.round(inches * 2.54) : Math.round(inches);
  onHeightChange(s.value);
}
function onWeightChange(v) {
  v = parseInt(v, 10);
  userProfile.weightLbs = (wUnit === 'kg') ? v * 2.2046 : v;
  document.getElementById('val-disp-weight').innerText = v + ' ' + wUnit;
  document.getElementById('btn-submit-w').innerText = 'I weigh ' + v + ' ' + wUnit + ' →';
}
function setWUnit(u) {
  if (u === wUnit) return;
  var lbs = userProfile.weightLbs;
  wUnit = u;
  document.getElementById('btn-w-lb').classList.toggle('active', u === 'lb');
  document.getElementById('btn-w-kg').classList.toggle('active', u === 'kg');
  var s = document.getElementById('slider-w');
  s.min = (u === 'kg') ? 35 : 80;
  s.max = (u === 'kg') ? 120 : 250;
  s.value = (u === 'kg') ? Math.round(lbs / 2.2046) : Math.round(lbs);
  onWeightChange(s.value);
}

function selectM(btn, type, val) {
  btn.parentElement.querySelectorAll('.ogl-m-btn').forEach(function (b) { b.classList.remove('active'); });
  btn.classList.add('active');
  userProfile[type] = val;
}
function selectBodyShape(card, shape) {
  document.querySelectorAll('.ogl-shape-card').forEach(function (c) { c.classList.remove('active'); });
  card.classList.add('active');
  userProfile.bodyShape = shape;
  goStep(6);
}
function skipBodyShape() { userProfile.bodyShape = null; goStep(6); }

var SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL'];
var MID = {
  bust:  [32.5, 34.5, 36.5, 38.5, 41, 43.5],
  waist: [25.5, 27.5, 29.5, 31.5, 34, 36.5],
  hip:   [34.5, 36.5, 38.5, 41, 44, 47],
  bmi:   [17, 19, 21, 23.5, 26.5, 30]
};

function fracIdx(arr, v) {
  if (v <= arr[0]) return Math.max(-0.5, (v - arr[0]) / (arr[1] - arr[0]));
  for (var i = 0; i < arr.length - 1; i++) {
    if (v <= arr[i + 1]) return i + (v - arr[i]) / (arr[i + 1] - arr[i]);
  }
  return Math.min(5.5, 5 + (v - arr[5]) / (arr[5] - arr[4]));
}

function blend(parts, shift) {
  var total = 0, sum = 0, i;
  for (i = 0; i < parts.length; i++) { sum += parts[i].idx * parts[i].w; total += parts[i].w; }
  var idx = sum / total + (shift || 0);
  var spread = 0;
  for (i = 0; i < parts.length; i++) { spread += parts[i].w / total * Math.abs(parts[i].idx - idx); }
  var clamped = Math.max(0, Math.min(5, idx));
  var size = Math.round(clamped);
  var offCenter = Math.abs(clamped - size);
  var conf = 98 - spread * 12 - offCenter * 16;
  if (idx < -0.35 || idx > 5.35) conf -= 6;
  conf = Math.round(Math.max(76, Math.min(98, conf)));
  return { size: size, idx: clamped, conf: conf, between: offCenter >= 0.36 };
}

function calculateAccurateFit() {
  var p = userProfile;
  var hIn = p.heightInches, wLb = p.weightLbs;
  var bmi = 703 * wLb / (hIn * hIn);

  var bustI  = fracIdx(MID.bust,  p.bust);
  var waistI = fracIdx(MID.waist, p.waist);
  var hipI   = fracIdx(MID.hip,   p.hip);
  var bmiI   = fracIdx(MID.bmi,   bmi);

  var topW = { bust: 0.62, waist: 0.14, bmi: 0.24 };
  var botW = { hip: 0.52, waist: 0.30, bmi: 0.18 };
  var topShift = 0, botShift = 0;

  switch (p.bodyShape) {
    case 'Pear':               botW = { hip: 0.68, waist: 0.14, bmi: 0.18 }; break;
    case 'Apple':              topW = { bust: 0.45, waist: 0.31, bmi: 0.24 };
                               botW = { hip: 0.40, waist: 0.42, bmi: 0.18 }; topShift = 0.1; break;
    case 'Inverted Triangle':  topW = { bust: 0.74, waist: 0.08, bmi: 0.18 };
                               botW = { hip: 0.60, waist: 0.24, bmi: 0.16 }; break;
    case 'Hourglass':          topW = { bust: 0.66, waist: 0.12, bmi: 0.22 };
                               botW = { hip: 0.58, waist: 0.26, bmi: 0.16 }; break;
    case 'Rectangle':          topW = { bust: 0.60, waist: 0.18, bmi: 0.22 };
                               botW = { hip: 0.46, waist: 0.38, bmi: 0.16 }; break;
  }

  var top = blend([
    { idx: bustI,  w: topW.bust },
    { idx: waistI, w: topW.waist },
    { idx: bmiI,   w: topW.bmi }
  ], topShift);

  var bot = blend([
    { idx: hipI,   w: botW.hip },
    { idx: waistI, w: botW.waist },
    { idx: bmiI,   w: botW.bmi }
  ], botShift);

  var topMsg = 'Based on your bust, waist, height and weight, size ' + SIZES[top.size] + ' will fit you comfortably and look great.';
  if (top.between) {
    topMsg = 'You are between sizes. ' + SIZES[top.size] + ' is your closest match; choose ' + (top.idx > top.size ? SIZES[Math.min(5, top.size + 1)] : SIZES[Math.max(0, top.size - 1)]) + ' for a ' + (top.idx > top.size ? 'more relaxed' : 'closer') + ' fit.';
  }
  var botMsg = 'Based on your hip, waist, height and weight, size ' + SIZES[bot.size] + ' will give you that perfect balance of comfort and style.';
  if (bot.between) {
    botMsg = 'You are between sizes. ' + SIZES[bot.size] + ' is your closest match; choose ' + (bot.idx > bot.size ? SIZES[Math.min(5, bot.size + 1)] : SIZES[Math.max(0, bot.size - 1)]) + ' for a ' + (bot.idx > bot.size ? 'more relaxed' : 'closer') + ' fit.';
  }
  if (hIn >= 69) botMsg += ' Our inseam is 30" (76 cm), so pants may sit slightly shorter on you.';
  else if (hIn <= 60) botMsg += ' Our inseam is 30" (76 cm), so pants may need hemming.';

  setResult('top', SIZES[top.size], top.conf, topMsg);
  setResult('bot', SIZES[bot.size], bot.conf, botMsg);

  document.getElementById('pdp-recom-text').innerText =
    'Top: ' + SIZES[top.size] + ' / Pants: ' + SIZES[bot.size] + ' are Recommendations.';
}

function setResult(key, size, conf, msg) {
  document.getElementById('res-' + key + '-size').innerText = size;
  document.getElementById('res-' + key + '-badge').innerText = size;
  var bar = document.getElementById('res-' + key + '-bar');
  bar.style.width = conf + '%';
  bar.innerText = conf + '%';
  document.getElementById('res-' + key + '-msg').innerText = msg;
}

function saveOglProfile() {
  var input = document.getElementById('ogl-email-input');
  var msg = document.getElementById('ogl-email-msg');
  var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
  msg.innerText = ok ? 'Profile saved. Thank you!' : 'Please enter a valid email address.';
}

function switchChartTab(evt, id) {
  document.querySelectorAll('.ogl-c-content').forEach(function (p) { p.classList.remove('active'); });
  document.querySelectorAll('.ogl-tab-item').forEach(function (b) { b.classList.remove('active'); });
  document.getElementById(id).classList.add('active');
  evt.currentTarget.classList.add('active');
  document.getElementById('ogl-unit-row').style.visibility = (id === 'c-country') ? 'hidden' : 'visible';
}
function changeUnit(u) {
  document.getElementById('unit-btn-in').classList.toggle('active', u === 'IN');
  document.getElementById('unit-btn-cm').classList.toggle('active', u === 'CM');
  document.querySelectorAll('.u-in').forEach(function (e) { e.classList.toggle('ogl-none', u !== 'IN'); });
  document.querySelectorAll('.u-cm').forEach(function (e) { e.classList.toggle('ogl-none', u !== 'CM'); });
}

/* ---- placement: put the Size Guide row right above the Size option, once ---- */
(function () {
  function place() {
    if (document.querySelector('.ogl-pdp-size-row')) return;
    var tpl = document.getElementById('ogl-tpl');
    if (!tpl) return;
    var anchor = null;
    var groups = document.querySelectorAll('variant-selects .product-form__input, variant-radios .product-form__input, product-info .product-form__input');
    for (var i = 0; i < groups.length && !anchor; i++) {
      var lab = groups[i].querySelector('legend, label');
      var t = (lab ? lab.textContent : '').toLowerCase();
      if (/\b(size|taglia|misura|taille|grootte|maat|größe|talla)\b/.test(t)) anchor = groups[i];
    }
    if (!anchor) anchor = document.querySelector('variant-selects, variant-radios');
    if (!anchor) anchor = document.querySelector('product-info .product-form, .product-form');
    if (!anchor) return;
    var old = document.getElementById('ogl-app-modal');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    anchor.insertAdjacentHTML('beforebegin', tpl.innerHTML);
    var m = document.getElementById('ogl-app-modal');
    if (m) document.body.appendChild(m);
    if (tpl.getAttribute('data-unit') === 'CM') { try { changeUnit('CM'); } catch (e) {} }
  }
  var tmr;
  function later() { clearTimeout(tmr); tmr = setTimeout(place, 250); }
  function init() { place(); try { new MutationObserver(later).observe(document.body, { childList: true, subtree: true }); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
